import { z } from 'zod';
import { IsoDateTimeSchema } from './common.js';
import { DeviceIdentityFieldsSchema } from './device-identity.js';
/** TV-started session — no organisation yet. */
export const CreatePairingSessionRequestSchema = z
    .object({
    deviceCode: z.string().min(1),
    appVersion: z.string().min(1).optional(),
    ttlSeconds: z.number().int().positive().max(3600).optional(),
})
    .merge(DeviceIdentityFieldsSchema);
export const PairingSessionCreatedSchema = z.object({
    code: z.string().min(1),
    expiresAt: IsoDateTimeSchema,
});
export const PairingSessionStatusSchema = z.enum(['pending', 'approved', 'claimed', 'expired']);
/**
 * Player poll. Token is returned once when the session becomes ready, then
 * status moves to claimed and token is omitted on later polls.
 */
export const PairingSessionPollSchema = z.object({
    status: PairingSessionStatusSchema,
    expiresAt: IsoDateTimeSchema,
    deviceId: z.string().min(1).optional(),
    screenId: z.string().min(1).nullable().optional(),
    token: z.string().min(1).optional(),
});
export const ApprovePairingSessionRequestSchema = z.object({
    screenId: z.string().min(1),
});
export const ApprovePairingSessionResponseSchema = z.object({
    code: z.string().min(1),
    screenId: z.string().min(1),
    deviceId: z.string().min(1),
    status: z.literal('approved'),
});
//# sourceMappingURL=pairing-session.js.map